import { PreventScroll, ShouldPreventScroll } from '@/components/utils/DeviceUtils';

const PlatformController = () => {
    if (ShouldPreventScroll()) {
        PreventScroll();
    }
};

export default PlatformController;
